const PROHIBITED_HTML_TAGS_REGEXP =
  /(?:(?:<\s*(title)[^>]*>)(?:.|\n)*(?:<\/\s*\1\s*>))|(?:<\s*base[^>]*(?:\/)?>)/gm;

const PROHIBITED_HTML_TAGS_ERROR_MESSAGE = '<title> and <base> tags are prohibited.';

function getProhibitedHtmlTagAnnotations(value = '', session) {
  if (!session) {
    return [];
  }

  const matches = [];
  const regexp = new RegExp(PROHIBITED_HTML_TAGS_REGEXP.source, PROHIBITED_HTML_TAGS_REGEXP.flags);

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const match = regexp.exec(value);

    if (!match) break;

    matches.push(match);
  }

  return matches.map((match) => {
    const editorPosition = session.doc.indexToPosition(match.index);

    return {
      ...editorPosition,
      type: 'error',
      text: PROHIBITED_HTML_TAGS_ERROR_MESSAGE,
    };
  });
}

export default getProhibitedHtmlTagAnnotations;
